import { Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Blast radius of the correction: agents and workflows that consume the record,
 * as chips, plus a plain-language notice of when the change lands.
 */
function ImpactBlock({ impact }) {
  const { t } = useTranslation('work-queues-app');
  if (!impact) return null;
  const { agents = [], workflows = [] } = impact;
  if (!agents.length && !workflows.length) return null;

  const rows = [
    { label: t('trainMe.agentsLabel'), items: agents },
    { label: t('trainMe.workflowsLabel'), items: workflows },
  ].filter((row) => row.items.length);

  return (
    <div className="border-t border-edge pt-5">
      <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
        {t('trainMe.impact')}
      </p>
      <div className="mt-3 flex flex-col gap-2">
        {rows.map((row) => (
          <div key={row.label} className="flex items-start justify-between gap-3">
            <p className="pt-0.5 text-xs uppercase tracking-wide text-content-faint">{row.label}</p>
            <div className="flex flex-wrap justify-end gap-1.5">
              {row.items.map((item) => (
                <Badge key={item} variant="neutral" size="medium" className="!border-transparent">
                  {item}
                </Badge>
              ))}
            </div>
          </div>
        ))}
      </div>
      {agents.length > 0 && (
        <p className="mt-3 rounded-lg border border-edge bg-surface-muted px-4 py-3 text-sm text-content-secondary">
          {t('trainMe.impactNotice', { count: agents.length })}
        </p>
      )}
    </div>
  );
}

export default ImpactBlock;
